// import React, { useState } from "react";
// import styles from "../styles/PremiumFSICalculator.module.css";
// import { useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";

// const PremiumFSICalculator = () => {
//   const [converterType, setConverterType] = useState("⁠Premium for Premium FSI");
//   const [fsiArea, setFsiArea] = useState("");
//   const [reckonerRate, setReckonerRate] = useState("");
//   const [premium, setPremium] = useState(null);
//   const navigate = useNavigate();

//   // Back button
//   const handleBack = () => {
//     navigate(-1);
//   };

//   // Dropdown change navigation
//   const handleDropdownChange = (e) => {
//     const selected = e.target.value;
//     setConverterType(selected);

//     const pathMap = {
//       "Area Convertor": "/area-convertor",
//       "Built-up Area Calculator": "/built-up-area-calculator",
//       "Development Charges": "/development-charges",
//       "Premium for Ancillary FSI": "/ancillary-fsi",
//       "⁠Premium for Premium FSI": "/premium-fsi",
//       "ULC Premium": "/ulc-premium",
//     };

//     if (pathMap[selected]) {
//       navigate(pathMap[selected]);
//     }
//   };

//   // Calculate Premium
//   const handleCalculate = () => {
//     const area = parseFloat(fsiArea);
//     const rate = parseFloat(reckonerRate);

//     if (isNaN(area) || isNaN(rate)) {
//       alert("Please enter valid numbers for both fields.");
//       return;
//     }

//     const result = area * rate * 0.35;
//     setPremium(result);
//   };

//   return (
//     <div className={styles.PremiumFSICalculator_container}>
//       <div className={styles.PremiumFSICalculator_header}>
//         <button className={styles.PremiumFSICalculator_backButton} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>
//         <h2 className={styles.PremiumFSICalculator_title}>Conversion Calculator</h2>
//       </div>

//       {/* Dropdown */}
//       <div className={styles.PremiumFSICalculator_dropdownContainer}>
//         <select
//           value={converterType}
//           onChange={handleDropdownChange}
//           className={styles.PremiumFSICalculator_mainDropdown}
//         >
//           <option>Area Convertor</option>
//           <option>Built-up Area Calculator</option>
//           <option>Development Charges</option>
//           <option>Premium for Ancillary FSI</option>
//           <option>⁠Premium for Premium FSI</option>
//           <option>ULC Premium</option>
//         </select>
//       </div>

//       {/* Calculator Card */}
//       <div className={styles.PremiumFSICalculator_card}>
//         <h3 className={styles.PremiumFSICalculator_sectionTitle}>
//           Premium Amount for Premium FSI
//         </h3>

//         <div className={styles.PremiumFSICalculator_formGroup}>
//           <label className={styles.PremiumFSICalculator_label}>
//             Premium FSI Area (sq.m):
//           </label>
//           <input
//             type="number"
//             className={styles.PremiumFSICalculator_input}
//             value={fsiArea}
//             onChange={(e) => setFsiArea(e.target.value)}
//             placeholder="Enter area in sq.m"
//           />
//         </div>

//         <div className={styles.PremiumFSICalculator_formGroup}>
//           <label className={styles.PremiumFSICalculator_label}>
//             Ready Reckoner Rate (₹/sq.m):
//           </label>
//           <input
//             type="number"
//             className={styles.PremiumFSICalculator_input}
//             value={reckonerRate}
//             onChange={(e) => setReckonerRate(e.target.value)}
//             placeholder="Enter rate in ₹/sq.m"
//           />
//         </div>

//         <button
//           className={styles.PremiumFSICalculator_submitButton}
//           onClick={handleCalculate}
//         >
//           Submit
//         </button>

//         <h3 className={styles.PremiumFSICalculator_resultTitle}>Premium</h3>
//         <p className={styles.PremiumFSICalculator_resultValue}>
//           {premium !== null ? `₹ ${premium.toLocaleString(undefined, { maximumFractionDigits: 2 })}` : "—"}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default PremiumFSICalculator;








import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Layers, 
  Scaling, 
  TrendingUp, 
  Gem,
  ChevronRight,
  Info
} from "lucide-react";

const PremiumFSICalculator = () => {
  const [converterType, setConverterType] = useState("⁠Premium for Premium FSI");
  const [fsiArea, setFsiArea] = useState("");
  const [reckonerRate, setReckonerRate] = useState("");
  const [premium, setPremium] = useState(null);
  
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);

    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };

    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const handleCalculate = () => {
    const area = parseFloat(fsiArea);
    const rate = parseFloat(reckonerRate);

    if (isNaN(area) || isNaN(rate)) {
      alert("Please enter valid numbers for both fields.");
      return;
    }

    // Standard UDCPR 35% premium calculation
    const result = area * rate * 0.35;
    setPremium(result.toLocaleString('en-IN', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }));
  };

  return (
    /* FIXED: High-contrast background */
    <div className="min-h-screen bg-slate-100 pb-20">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={handleBack} className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600">
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">TPH Calc</h2>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-4 mt-10">
        {/* --- TOOL NAVIGATOR --- */}
        <div className="relative mb-10">
          <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 z-10" size={18} />
          <select
            value={converterType}
            onChange={handleDropdownChange}
            className="w-full bg-white border border-slate-300 rounded-2xl py-5 pl-12 pr-4 font-bold text-slate-800 appearance-none shadow-md focus:outline-none"
          >
            <option>Area Convertor</option>
            <option>Built-up Area Calculator</option>
            <option>Development Charges</option>
            <option>Premium for Ancillary FSI</option>
            <option>⁠Premium for Premium FSI</option>
            <option>ULC Premium</option>
          </select>
          <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={18} />
        </div>

        {/* --- MAIN CARD --- */}
        {/* FIXED: Added shadow-2xl and ring-1 to prevent merging with background */}
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/40 ring-1 ring-slate-200 overflow-hidden">
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight">Premium FSI</h3>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">FSI Optimization Tool</p>
            </div>
            <div className="w-10 h-10 bg-orange-600 rounded-xl flex items-center justify-center shadow-lg shadow-orange-900/20">
              <Gem size={20} />
            </div>
          </div>

          <div className="p-8 space-y-8">
            <div className="bg-orange-50/50 p-4 rounded-xl border border-orange-100/50">
               <p className="text-[11px] text-orange-700 font-black flex items-center gap-2">
                 <Info size={14} /> UDCPR Standard: 35% Premium calculation applied.
               </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                  <Scaling size={14} /> FSI Area (sq.m)
                </label>
                <div className="relative">
                  <input
                    type="number"
                    placeholder="0.00"
                    value={fsiArea}
                    onChange={(e) => setFsiArea(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all shadow-sm"
                  />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">sq.m</span>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                  <TrendingUp size={14} /> RR Rate (₹/sq.m)
                </label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-slate-400">₹</span>
                  <input
                    type="number"
                    placeholder="Rate"
                    value={reckonerRate}
                    onChange={(e) => setReckonerRate(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 pl-8 font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all shadow-sm"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={handleCalculate}
              className="w-full bg-orange-600 hover:bg-orange-700 text-white py-5 rounded-2xl font-black text-lg transition-all transform active:scale-[0.98] shadow-xl shadow-orange-600/30"
            >
              Calculate Premium
            </button>
          </div>

          {/* --- RESULTS SECTION --- */}
          <div className="bg-orange-50/80 p-10 border-t border-orange-100 text-center">
            <h4 className="text-[10px] font-black text-orange-600 uppercase tracking-widest mb-3 flex items-center justify-center gap-2">
              <Info size={14} /> Total FSI Premium
            </h4>
            <div className="text-5xl font-black text-slate-900 tracking-tight">
              <span className="text-2xl mr-1 opacity-30 font-medium">₹</span>
              {premium || "0.00"}
            </div>
          </div>
        </div>

        <p className="text-center mt-8 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel • Real Estate Risk Intelligence
        </p>
      </main>
    </div>
  );
};

export default PremiumFSICalculator;